import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService, RegistrationStep } from 'angular-lib';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../../services/loader.service';
import { RegistrationModel } from 'angular-lib';

@Component({
    selector: 'ez-register-user',
    template: require('./register-user.component.html'),
    styles: [require('./register-user.component.less')]
})
export class RegisterUserComponent extends RegistrationStep implements OnInit {
    @ViewChild('template', {read: ViewContainerRef}) private template: ViewContainerRef;
    @ViewChild('displayNameRef') private displayNameRef: ElementRef;
    @ViewChild('secondEmailInput') private secondEmailInput: ElementRef;
    @ViewChild('iovationBlackBoxInput') private iovationBlackBoxInput: ElementRef;


    public errorStrings;
    public emailBis: string = '';
    public showDoubleInputEmail: boolean = false;
    public notifyLegalsTypeStr?: string;
    public cguSentence: string = '';
    public iovationBlackBox: string = '';

    public errors: any = {};

    constructor(
        private translate: TranslateService,
        private apiService: ApiService,
        private router: Router,
        private loaderService: LoaderService
    ) {
        super();
    }

    public ngOnInit() {
        this.translate.get([
            'registration.accept-tos',
            'common.tos',
            'registration.private-life',
            'registration.private-life-content'
        ]).subscribe((translations) => {
            this.cguSentence =
                translations['registration.accept-tos'].replace(
                    /<CGU>/,
                    '<span>' +
                    translations['common.tos'] + '</span>'
                ) +
                translations['registration.private-life'].replace(
                    /<Vieprivee>/,
                    '<span>' +
                    translations['registration.private-life-content'] + '</span>') + ' *';
        });

        this.initLegals();
        this.initErrorString();
    }

    /**
     * Check if the email at input blur
     */
    public showDoubleEmailOnBlur() {
        if (this.emailOk() === false) {
            this.errors.email = true;
            return false;
        } else if (this.errors.email === true) {
            this.errors.email = false;
        }

        // Check double input (if hotmail|live|yahoo|outlook)
        let verif = new RegExp('@(hotmail|live|yahoo|outlook)\\.', 'g');
        this.showDoubleInputEmail = verif.exec(this.registrationModel.email) !== null;
        if (this.showDoubleInputEmail === true) {
            this.errors.doubleEmail = true;
            this.secondEmailInput.nativeElement.focus();
        } else {
            this.errors.doubleEmail = false;
        }

        return this.showDoubleInputEmail;
    }

    public checkDisplayName() {
        return this.registrationModel.displayName
            && this.registrationModel.displayName.length > 1;
    }

    /**
     * Check the double email inputs
     */
    public doubleEmailChecked() {
        let r = this.registrationModel.email === this.emailBis;
        if (r) {
            delete this.errors.doubleEmail;
        }
        return r;
    }

    /**
     * Automatically populate display name according to the email
     */
    public populateDisplayName() {
        if (
            this.emailOk() &&
            (this.registrationModel.displayName === '' || !this.registrationModel.displayName)
        ) {
            let displayName = this.registrationModel
                .email
                .substr(0, this.registrationModel.email.lastIndexOf('@')).replace(/[^_a-zA-Z0-9]+/g, '');
            if (displayName.length > 15) {
                displayName = displayName.substr(0, 15);
            }

            this.registrationModel.displayName = displayName;
        }
    }

    /**
     * Show the CGU page
     */
    public showCGU($event) {
        if ($event.target.tagName === 'SPAN' && $event.target.className === '') {
            this.router.navigate(['/legals/cgu']);
            $event.preventDefault();
            return false;
        }
    }

    public initLegals() {
        let useReturnPath = this.miscConfig.siteUseReturnPath;
        if (useReturnPath === true && (this.translate.currentLang === 'fr')) {
            this.notifyLegalsTypeStr = 'registration.data-returnpath';
        } else if (useReturnPath === true) {
            this.apiService.geolocIp().subscribe((data: any) => {
                if (data.country.id === 78) {
                    this.notifyLegalsTypeStr = 'registration.data-returnpath';
                }
            });
        } else {
            this.notifyLegalsTypeStr = 'registration.data-basic';
        }
    }

    public emailOk(): boolean {
        return this.registrationModel.email
            && this.registrationModel.email.match(/^.*@.*\..+$/) != null;
    }

    public validRules() {
        let rules: any = {
            'cgu': this.registrationModel.cguAccepted === true,
            'display_name': this.checkDisplayName(),
            'email': this.emailOk(),
        };

        if (this.showDoubleEmailOnBlur() === true) {
            rules.doubleEmail = this.doubleEmailChecked();
        }

        let toto = true;
        Object.keys(rules).forEach(i => {
            let result = rules[i];
            toto = toto && result;
            if (!result) {
                this.errors[i] = true;
            } else {
                delete this.errors[i];
            }
        });

        return toto;
    }

    /**
     * Register the user
     */
    public validRegistration() {
        if (this.validRules()) {
            this.loaderService.show();
            if (this.request) {
                return;
            }

            // iovation
            this.registrationModel.ioBB = this.iovationBlackBoxInput.nativeElement.value;

            this.request = this.apiService.registerUser(this.registrationModel).subscribe(
                data => {
                    if (data.success === true) {
                        if (data.jwt) {
                            localStorage.setItem(environment.tokenName, data.jwt);
                        }
                        this.apiService.saveRegistrationStep(this.registrationModel);
                        this.submit();
                    } else {
                        this.request = null;

                        if (data.errors) {
                            Object.keys(data.errors).forEach(i => {
                                if (data.errors[i] !== null) {
                                    this.errors[i] = data.errors[i];
                                }
                            });
                        }

                        if (data.iovationDenied === true) {
                            localStorage.removeItem(RegistrationModel.localeStorageKey);
                            window.location.href = environment.iovation.deniedLink;
                        }
                    }
                    this.loaderService.hide();
                },
                _ => {
                    this.request = null;
                    this.loaderService.hide();
                }
            );
        }
    }

    public initErrorString() {
        return this.translate.get([
            'registration.validator.login-empty',
            'registration.validator.email-not-valid',
        ]).subscribe(a => this.errorStrings = a);
    }

    public errorString(key: string) {
        if (typeof this.errors[key] === 'string') {
            return this.errors[key];
        } else if (this.errors[key]) {
            switch (key) {
                case 'email':
                    return this.errorStrings['registration.validator.email-not-valid'];
                case 'display_name':
                    return this.errorStrings['registration.validator.login-empty'];
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/register-user/register-user.component.ts